import { Box, Divider, Drawer } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import Logo from '#/assets/layout/logo.png'
import AppDownloadBanner from '#/components/Layout/AppDownloadBanner'
import Header from '#/components/Layout/Header'
import Menu from '#/components/Layout/Menu'
import { useFarmSlug } from '#/store/ducks/farm'
import useWidth from '#/store/hooks/useWidth'
import Colors from '#/styles/Old/Colors'
import Palette from '#/styles/Old/Palette'

const HeaderLogoWrapper = styled(Box)({
  'backgroundColor': Colors.darkSecondary,
  'display': 'flex',
  '& :hover': {
    cursor: 'pointer',
  },
})

const HeaderLogo = styled('div')(({ theme }) => ({
  'display': 'flex',
  'alignItems': 'center',
  'justifyContent': 'flex-start',
  'padding': 30,
  'height': '64px',
  '& > img': {
    maxWidth: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    height: '48px',
  },
}))

const StyledDrawer = styled(Drawer)({
  '& >.MuiPaper-root': {
    width: 240,
    background: Palette.grey.darken[3],
    color: 'white',
    zIndex: 1,
  },
})

function Layout() {
  const width = useWidth()
  const farmSlug = useFarmSlug()
  const history = useHistory()
  const isMobile = ['xs', 'sm', 'md'].includes(width)

  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [desktopOpen, setDesktopOpen] = React.useState(!isMobile)

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen)
    } else {
      setDesktopOpen(!desktopOpen)
    }
  }

  useEffect(() => {
    if (mobileOpen && isMobile) {
      setMobileOpen(false)
    }
  }, [width])

  const goHome = () => {
    history.push(farmSlug ? `/farm/${farmSlug}` : '/')
  }

  const drawer = (
    <Box id="menu-drawer">
      <HeaderLogoWrapper onClick={goHome}>
        <HeaderLogo>
          <img alt="COWMED" src={Logo} />
        </HeaderLogo>
      </HeaderLogoWrapper>
      <Divider />
      <Menu />
    </Box>
  )

  return (
    <Box>
      <AppDownloadBanner />
      <Header width={width} setMobileOpen={setMobileOpen} setDesktopOpen={setDesktopOpen} />
      <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
        {isMobile && (
          <StyledDrawer
            variant="temporary"
            anchor="left"
            open={mobileOpen}
            onClose={handleDrawerToggle}
          >
            {drawer}
          </StyledDrawer>
        )}
      </Box>
      <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <StyledDrawer variant="permanent" anchor="left" open>
          {drawer}
        </StyledDrawer>
      </Box>
    </Box>
  )
}

export default Layout
